import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {colors} from 'shells/colors/colors';
import {WhatsAppIcon} from 'shells/icon/svg/whatsapp-icon';
import {IntegrationWidget} from 'shells/integration-widget/integration-widget';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Body} from 'shells/typography/body';

type Props = {
    isEnabled: boolean;
    whatsappPhoneNumber: string | null | undefined;
    enableIntegration: () => void;
    disableIntegration: () => void;
    shouldSyncContacts: boolean;
    shouldSyncMessages: boolean;
    setShouldSyncContacts: (shouldSyncContacts: boolean) => void;
    setShouldSyncMessages: (shouldSyncMessages: boolean) => void;
};

export function Connected(props: Props) {
    return (
        <OnboardingBody title='✅ You’re connected!'>
            <div className='mt-16'>
                <StackLegacy spacing={48}>
                    <IntegrationWidget
                        status={props.isEnabled ? 'enabled' : 'disabled'}
                        account={props.whatsappPhoneNumber}
                        initialText='Connect to WhatsApp business'
                        logo={
                            <WhatsAppIcon
                                size={24}
                                alignCenter={true}
                                wrapWithDiv={false}
                                // @ts-expect-error
                                color={colors.whatsappGreen}
                            />
                        }
                        onConnectClick={props.enableIntegration}
                        onDisconnectClick={props.disableIntegration}
                        onlyDisable={true}
                    />
                    <StackLegacy spacing={16}>
                        <Body isBold={true}>Get started even faster:</Body>
                        <Checkbox
                            checked={props.shouldSyncContacts}
                            onChange={() => props.setShouldSyncContacts(!props.shouldSyncContacts)}
                            label='Create people from my existing WhatsApp contacts'
                        />
                        <Checkbox
                            checked={props.shouldSyncMessages}
                            onChange={() => props.setShouldSyncMessages(!props.shouldSyncMessages)}
                            label='Import my last 6 months of conversation history'
                        />
                    </StackLegacy>
                </StackLegacy>
            </div>
        </OnboardingBody>
    );
}
